import IconSearch from '@icons/Search'
import { suburbsAutocomplete } from '@lib/api-services/suburbService'
import { Router } from '@routes'
import { useId, useState } from 'react'
import AsyncSelect from 'react-select/async'
import { useDebouncedCallback } from 'use-debounce'
import * as S from './SuburbProfileSearchForm.styled'
import Button from '@global/Button'
import useWindowSize from '@hooks/useWindowSize'

const SuburbProfileSearchForm = () => {
  const selectInstanceId = useId()
  const [isFocused, setIsFocused] = useState(false)
  const [searchText, setSearchText] = useState('')
  const [selectedOption, setSelectedOption] = useState(null)
  const windowSize = useWindowSize()

  const debouncedSearch = useDebouncedCallback(async (q, callback) => {
    if (q?.length < 3) {
      callback([])
      return
    }

    let options = []
    const res = await suburbsAutocomplete({ q, limit: 5 })
    res.region_indexes?.forEach((item) => {
      options.push({
        label: item.title,
        value: item.url,
      })
    })
    res.regions?.forEach((item) => {
      options.push({
        label: item.title,
        value: item.url,
      })
    })
    res.suburbs?.forEach((item) => {
      options.push({
        label: `${item.title} (${item.region_name})`,
        value: item.url,
      })
    })
    callback(options)
  }, 300)

  const loadOptions = (q, callback) => {
    setSearchText(q)
    debouncedSearch(q, callback)
  }

  const onSearch = () => {
    if (selectedOption?.value) {
      Router.pushRoute(selectedOption.value)
    }
  }

  const onChange = (selectedOption) => {
    if (windowSize.width <= 768) {
      setSelectedOption(selectedOption)
      Router.pushRoute(selectedOption.value)
    } else {
      setSelectedOption(selectedOption)
    }
  }

  return (
    <S.SuburbProfileSearchForm>
      <IconSearch />
      <AsyncSelect
        instanceId={selectInstanceId}
        loadOptions={loadOptions}
        onChange={onChange}
        classNamePrefix='bp-autocomplete'
        className='bp-autocomplete'
        components={{
          IndicatorSeparator: () => null,
          DropdownIndicator: () => null,
          ClearIndicator: () => null,
        }}
        noOptionsMessage={() =>
          searchText?.length < 3 ? null : 'No results found'
        }
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
        onMenuClose={() => setSearchText('')}
        placeholder={
          isFocused
            ? ''
            : 'Search for suburb profiles by suburb name, postcode, municipality or region'
        }
        menuPosition='absolute'
        blurInputOnSelect={false}
        menuPlacement='auto'
        menuPortalTarget={null}
        styles={{
          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
        }}
      />
      <Button
        border
        color='secondary'
        style={{ minWidth: '132px' }}
        onClick={onSearch}
      >
        Search
      </Button>
    </S.SuburbProfileSearchForm>
  )
}

SuburbProfileSearchForm.defaultProps = {}

export default SuburbProfileSearchForm
